/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Debrief_RetryInputs */



/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Practice_Session_Debrief_RetryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_debrief_retry = /** @type {((inputs?: Practice_Session_Debrief_RetryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Debrief_RetryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Probeer opnieuw")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réessayer")
	return /** @type {LocalizedString} */ ("Try again")
});